<div>
  <div class="filter-container">
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header class="filter-header">
        <mat-toolbar color="primary" class="filter-toolbar">
          <span>Filtros</span>
        </mat-toolbar>
      </mat-expansion-panel-header>
      <form [formGroup]="filterFormGroup">
        <div class="filter-content">
          <mat-form-field class="filter-field" appearance="outline">
            <mat-label>Descrição</mat-label>
            <input class="noMovimentacaoInput" matInput type="text" formControlName="noMovimentacao">
          </mat-form-field>
          <mat-form-field class="filter-field" appearance="outline">
            <mat-label>Valor</mat-label>
            <input matInput type="number" formControlName="vlMovimentacao">
          </mat-form-field>
          <div class="filter-field-flex">
            <mat-form-field class="filter-field-date" appearance="outline">
              <mat-label>Data de Movimentação</mat-label>
              <mat-date-range-input [formGroup]="filterDtMovimentacao" [rangePicker]="picker">
                <input matStartDate placeholder="Data Inicial" formControlName="dtIni">
                <input matEndDate placeholder="Data Final" formControlName="dtFim">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
              <span class="mat-form-field-subscript-wrapper">
                <mat-error *ngIf="filterDtMovimentacao.controls.dtIni.hasError('matStartDateInvalid')">Data inicial
                  inválida</mat-error>
                <mat-error *ngIf="filterDtMovimentacao.controls.dtFim.hasError('matEndDateInvalid')">Data
                  final inválida</mat-error>
              </span>
            </mat-form-field>

            <mat-form-field class="filter-field-date" appearance="outline">
              <mat-label>Data de Vencimento</mat-label>
              <mat-date-range-input [formGroup]="filterDtVencimento" [rangePicker]="picker2">
                <input matStartDate placeholder="Data Inicial" formControlName="dtIni">
                <input matEndDate placeholder="Data Final" formControlName="dtFim">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-date-range-picker #picker2></mat-date-range-picker>
              <mat-error *ngIf="filterDtVencimento.controls.dtIni.hasError('matStartDateInvalid')">Data
                inicial inválida</mat-error>
              <mat-error *ngIf="filterDtVencimento.controls.dtFim.hasError('matEndDateInvalid')">Data final
                inválida</mat-error>
            </mat-form-field>

          </div>
          <mat-form-field class="filter-field" appearance="outline">
            <mat-label>Tipo Movimento</mat-label>
            <input matInput type="text" formControlName="noTipoMovimento">
          </mat-form-field>

          <div class="filter-actions">
            <button mat-raised-button color="primary" class="filter-button" [disabled]="filterFormGroup.invalid"
              (click)="onFilter()">
              <mat-icon>search</mat-icon>
              Buscar
            </button>
            <button mat-raised-button color="warn" class="filter-button" [disabled]="isAcaoDisabled()"
              (click)="onClear()">
              <mat-icon>clear</mat-icon>
              Limpar
            </button>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
  </div>

  <app-lista-dados
    [upTitulo]="'Movimentos Financeiros'"
    [upIcone]="'account_balance_wallet'"
    [upCor]="'3F51B5'"
    [upDados]="movimentos"
    [upColunas]="colunas"
    [upHabilitaBotaoIncluir]="false"
    [upHabilitaBotaoExcluir]="false"
    [upHabilitaEditarLinha]="false"
    [upHabilitaContador]="true"
    [upHabilitaFiltroRapido]="true"
    [upItensPorPagina]="25"
    [upOpcoesItensPorPagina]="[25, 50, 75, 100]"
    [upCarregando]="!!subscription"
    (ueBotaoEditar)="onEdit($event)">
  </app-lista-dados>
</div>
